import BrandLogo from "@/components/BrandLogo";
import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useBranding } from "@/context/BrandingContext";

export default function ResetPassword() {
  const { applyNeutral, exitNeutral } = useBranding();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  useEffect(() => { applyNeutral(); return () => exitNeutral(); }, [applyNeutral, exitNeutral]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setOk(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dd-night p-6">
      <div className="w-full max-w-sm bg-white rounded-xl p-8">
        <div className="mb-6"><BrandLogo className="h-12" /></div>
        <h2 className="text-2xl font-bold text-dd-blue">{params.get("invite") ? "Bienvenue — choisissez votre mot de passe" : "Nouveau mot de passe"}</h2>
        {ok ? (
          <p className="mt-4 text-sm text-dd-night" data-testid="reset-done">Mot de passe modifié. Redirection…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <div>
              <Label className="text-dd-night">Mot de passe</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required minLength={8} className="mt-1 h-11" data-testid="reset-password" />
            </div>
            {error && <div className="text-sm text-destructive">{error}</div>}
            <Button type="submit" className="w-full h-11 bg-dd-blue hover:bg-dd-night text-white" data-testid="reset-submit">
              Réinitialiser
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-sm text-dd-blue hover:underline">Retour à la connexion</Link>
      </div>
    </div>
  );
}
